module.exports = __webpack_public_path__ + "Frutiger-Cn.woff?52bcf9461568032b52e5efd4bbd68a01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Frutiger-Cn.woff
// module id = 43
// module chunks = 0